export default __webpack_public_path__ + "static/media/swag2.ea02e61c.jpg";